import React from 'react';

import FCard from './FCard/FCard';
import MCard from './MCard/MCard';

class QuestionCard extends React.Component {
  componentDidMount() {
    if (this.props.flashcard === 'flashcardOnly') {
      this.props.updateIsCorrect(true);
    }
  }

  render() {
    const imageUrl = this.props.imageUrl;
    if (
      this.props.flashMode === true ||
      this.props.flashcard === 'flashcardOnly'
    ) {
      return (
        <FCard
          setClicked={this.props.setClicked}
          getClickedState={this.props.getClickedState}
          imageUrl={imageUrl}
          answers={this.props.answers ? this.props.answers : []}
        />
      );
    }
    return (
      <MCard
        {...this.props}
        renderSymbols={this.props.renderSymbols}
        updateIsCorrect={this.props.updateIsCorrect}
        setPreviousAnswerClicked={this.props.setPreviousAnswerClicked}
        showPreviousAnswer={this.props.showPreviousAnswer}
        previousAnswerClicked={this.props.previousAnswerClicked}
        answerId={this.props.answerId}
        fromReview={this.props.fromReview}
        answered={this.props.answerId}
        allowToChangeAnswer={this.props.allowToChangeAnswer}
      />
    );
  }
}

export default QuestionCard;
